import React from "react";

export function CircularScore({ score, max = 10 }) {
  const radius = 40;
  const stroke = 10;
  const normalizedRadius = radius - stroke / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const progress = (score / max) * 100;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <svg height={radius * 2} width={radius * 2}>
      <circle
        stroke='#e5e7eb' // light gray background circle
        fill='transparent'
        strokeWidth={stroke}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <circle
        stroke='#4b977b' // main progress color
        fill='transparent'
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeDasharray={circumference + " " + circumference}
        strokeDashoffset={strokeDashoffset}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
        style={{ transition: "stroke-dashoffset 0.35s" }}
        transform='rotate(270, 40, 40)'
      />
      <text
        x='50%'
        y='50%'
        dy='.3em'
        textAnchor='middle'
        fontSize='16'
        fill='#000'
        fontWeight='bold'
      >
        {score}
      </text>
    </svg>
  );
}
